import type { DateTimeTextProps } from '~/features/temporal';
import { Span } from '@workramp/ui';
import { DateTimeText } from '~/features/temporal';

export interface DateTimeCellProps extends Omit<DateTimeTextProps, 'date'> {
  date?: number | string | Date | null;
}

export function DateTimeCell({ date, ...props }: DateTimeCellProps) {
  return <Span size={1}>{date ? <DateTimeText date={date} {...props} /> : '--'}</Span>;
}
